module.exports = __webpack_public_path__ + "img/t7-5.dccda288.svg";